import { Document, LiveQuery, Subscription } from '@dittolive/ditto'
import { useEffect, useRef, useState } from 'react'

import { Issue, IssueStatus } from '../store/types'
import useCurrentApp from './useCurrentApp'
import useDittoClient from './useDittoClient'
import { stopLiveQuery } from './utils'

type Result = {
  issuesOpenedCount: number
  issuesClosedCount: number
  totalCount: number
}

/** WIP: Issues stats */
const useIssuesStats = (appId?: string): Result => {
  const { organizationId, viewerId } = useCurrentApp(appId || '')
  const client = useDittoClient()
  const [stats, setStats] = useState<Result>({
    issuesOpenedCount: 0,
    issuesClosedCount: 0,
    totalCount: 0,
  })
  const issuesStatsSub = useRef<Subscription | undefined>()
  const issuesStatsQuery = useRef<LiveQuery | undefined>()

  useEffect(() => {
    if (organizationId && appId && viewerId) {
      stopLiveQuery(issuesStatsQuery)
      issuesStatsSub.current?.cancel()
      const op = client.store
        .collection('issues')
        .find(`organizationId == '${organizationId}' && appId == '${appId}'`)
      issuesStatsSub.current = op.subscribe()
      issuesStatsQuery.current = op.observeLocal(
        (documents: Array<Document>) => {
          if (documents) {
            setStats({
              totalCount: documents.length,
              issuesClosedCount: documents.filter(
                (doc) =>
                  (doc.value as unknown as Issue).status === IssueStatus.closed,
              ).length,
              issuesOpenedCount: documents.filter(
                (doc) =>
                  (doc.value as unknown as Issue).status === IssueStatus.open,
              ).length,
            })
          }
        },
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId, appId, viewerId])

  useEffect(() => {
    return () => {
      stopLiveQuery(issuesStatsQuery)
      issuesStatsSub.current?.cancel()
    }
  }, [])
  return stats
}

export default useIssuesStats
